import { viewerEntity } from '../../shared/entities/viewer'

export const profileLoader = () => {
  return viewerEntity.fetchProfileFx()
}